import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from '../../context/CookieConsentContext';

function CookieConsentBanner() {
  const { t } = useTranslation();
  const { hasDecided, acceptAll, rejectAll, savePreferences } = useCookieConsent();
  const [expanded, setExpanded] = useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(false);

  if (hasDecided) return null;

  return (
    <div className="tw-fixed tw-bottom-4 tw-right-4 tw-z-[1000] tw-w-[calc(100%-2rem)] tw-max-w-sm">
      <div className="tw-rounded-2xl tw-bg-[#2d0a4d] tw-border tw-border-white/10 tw-shadow-2xl tw-p-5">
        <h2 className="tw-text-white tw-text-sm tw-font-semibold tw-m-0 tw-mb-2">
          {t('We value your privacy')}
        </h2>
        <p className="tw-text-white/70 tw-text-xs tw-leading-relaxed tw-m-0 tw-mb-4">
          {t('We use essential cookies to make our site work. With your consent, we’d also like to use analytics cookies to understand how the site is used.')}
        </p>

        {expanded && (
          <div className="tw-flex tw-flex-col tw-gap-3 tw-mb-4">
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-3">
              <div>
                <p className="tw-text-white tw-text-xs tw-font-medium tw-m-0">{t('Essential')}</p>
                <p className="tw-text-white/50 tw-text-[11px] tw-m-0">{t('Always active')}</p>
              </div>
              <input type="checkbox" checked disabled className="tw-h-4 tw-w-4 tw-text-[#712CB0] focus:tw-ring-[#712CB0]" />
            </div>
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-3">
              <div>
                <p className="tw-text-white tw-text-xs tw-font-medium tw-m-0">{t('Analytics')}</p>
                <p className="tw-text-white/50 tw-text-[11px] tw-m-0">{t('Helps us understand site usage')}</p>
              </div>
              <input
                type="checkbox"
                checked={analyticsEnabled}
                onChange={(e) => setAnalyticsEnabled(e.target.checked)}
                className="tw-h-4 tw-w-4 tw-text-[#712CB0] focus:tw-ring-[#712CB0]"
              />
            </div>
          </div>
        )}

        <div className="tw-flex tw-flex-col tw-gap-2">
          {expanded ? (
            <button
              type="button"
              onClick={() => savePreferences({ analytics: analyticsEnabled })}
              className="tw-w-full tw-rounded-lg tw-bg-[#712CB0] tw-text-white tw-text-xs tw-font-semibold tw-py-2 tw-border-0 tw-cursor-pointer hover:tw-bg-[#5e2393] tw-transition-colors"
            >
              {t('Save preferences')}
            </button>
          ) : (
            <button
              type="button"
              onClick={acceptAll}
              className="tw-w-full tw-rounded-lg tw-bg-[#712CB0] tw-text-white tw-text-xs tw-font-semibold tw-py-2 tw-border-0 tw-cursor-pointer hover:tw-bg-[#5e2393] tw-transition-colors"
            >
              {t('Accept all')}
            </button>
          )}
          <div className="tw-flex tw-gap-2">
            <button
              type="button"
              onClick={rejectAll}
              className="tw-flex-1 tw-rounded-lg tw-bg-transparent tw-text-white/70 tw-text-xs tw-font-medium tw-py-2 tw-border tw-border-white/10 tw-cursor-pointer hover:tw-bg-white/5 tw-transition-colors"
            >
              {t('Reject all')}
            </button>
            <button
              type="button"
              onClick={() => setExpanded((v) => !v)}
              className="tw-flex-1 tw-rounded-lg tw-bg-transparent tw-text-white/70 tw-text-xs tw-font-medium tw-py-2 tw-border tw-border-white/10 tw-cursor-pointer hover:tw-bg-white/5 tw-transition-colors"
            >
              {expanded ? t('Hide') : t('Customize')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
